var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-select',{attrs:{"options":_vm.citiesSelect,"value":_vm.value,"placeholder":_vm.loading ? 'Carregando...' : 'CIDADE'},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }